module.exports = __webpack_public_path__ + "static/media/poa_sample.eef471a5.png";